/**
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Pipe, PipeTransform} from '@angular/core';

const UNITS = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

@Pipe({name: 'fileSize'})
export class FileSizePipe implements PipeTransform {

  transform(bytes: number = 0, precision: number = 2): string {
    if (!isFinite(bytes)) { return ''; }

    let unit;
    for (unit = 0; bytes >= 1024; unit++) {
      bytes /= 1024;
    }

    const value = bytes.toFixed(Number(precision));
    return `${value} ${UNITS[unit]}`;
  }
}
